const getDynamicBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  if (typeof window !== "undefined" && window.location && window.location.hostname) {
    const host = window.location.hostname;
    if (host.includes("playez5050.manavtechlabs.in") || host.includes("manavtechlabs.in") || host.includes("ez5050.com")) {
      return "https://apiez5050.manavtechlabs.in/ez5050Api";
    }
    const protocol = window.location.protocol === "https:" ? "https:" : "http:";
    return `${protocol}//${host}:3005/ez5050Api`;
  }
  return "http://localhost:3005/ez5050Api";
};

const getDynamicSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) {
    return process.env.REACT_APP_SOCKET_URL;
  }
  if (typeof window !== "undefined" && window.location && window.location.hostname) {
    const host = window.location.hostname;
    if (host.includes("playez5050.manavtechlabs.in") || host.includes("manavtechlabs.in") || host.includes("ez5050.com")) {
      return "https://apiez5050.manavtechlabs.in";
    }
    const protocol = window.location.protocol === "https:" ? "https:" : "http:";
    return `${protocol}//${host}:3005/`;
  }
  return "http://localhost:3005/";
};

const getDynamicCrmUrl = () => {
  if (process.env.REACT_APP_CRM_URL) {
    return process.env.REACT_APP_CRM_URL;
  }
  if (typeof window !== "undefined" && window.location && window.location.hostname) {
    const host = window.location.hostname;
    if (host.includes("playez5050.manavtechlabs.in") || host.includes("manavtechlabs.in") || host.includes("ez5050.com")) {
      return "https://crm.ez5050.com";
    }
    const protocol = window.location.protocol === "https:" ? "https:" : "http:";
    return `${protocol}//${host}:3001`;
  }
  return "http://localhost:3001";
};

const consts = {
  type: process.env.REACT_APP_ENV || "Development",
  socketUrl: getDynamicSocketUrl(),
  MainUrl: typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : (process.env.REACT_APP_MAIN_URL || "http://localhost:3000"),
  BackendUrl: getDynamicBackendUrl(),

  defaultCrypto: "BTCUSDT",
  defaultForex: "EURUSD",
  defaultCommodity: "XAUUSD",
  CRMUrl: getDynamicCrmUrl(),
};

export default consts;
